import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from './util';
const Tiny = (_jsx("svg", Object.assign({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18" }, { children: _jsx("path", { d: "M12.81.58a.76.76 0 0 0-.75.75v6.49L5.63 1.38a.75.75 0 0 0-1.06 0 .74.74 0 0 0 0 1.06L11 8.91l-6.43 6.47a.74.74 0 0 0 0 1.06.75.75 0 0 0 1.06 0L12.06 10v6.5a.75.75 0 0 0 1.5 0V1.33a.75.75 0 0 0-.75-.75Z", fill: "currentColor" }, void 0) }), void 0));
export const variants = {
    tiny: Tiny,
    default: Tiny,
};
export default withVariants(variants);
